import HundredBricksAPIError from '../HundredBricksAPIError';
class ResendInactiveAccountError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ResendInactiveAccountError', ...args);
    }
}
export default ResendInactiveAccountError;
